import { FC } from 'react';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  color?: string;
  className?: string;
}

const getSizeClassName = (size: 'small' | 'medium' | 'large'): string => {
  switch (size) {
    case 'small':
      return 'w-5 h-5';
    case 'medium':
      return 'w-8 h-8';
    case 'large':
      return 'w-12 h-12';
  }
};

export const LoadingSpinner: FC<LoadingSpinnerProps> = ({ size = 'medium', className }) => {
  const sizeClassName = getSizeClassName(size);

  return (
    <div
      className={`${sizeClassName} border-2 border-sami-green rounded-full border-b-transparent animate-spin ${className}`}
    />
  );
};
